/* smart-answer-card-without-streaming-expand.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./smart-answer-card-without-streaming-expand.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment, Suspense, useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { Box } from '@atlaskit/primitives/compiled';
import { getFrontendExperiment } from '@atlassian/search-experiment';
import { AISources, useAnalytics } from '../../common';
import { SainAction, useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { AIAnswerBody } from '../ai-answer-body';
import { useAIAnswerContext } from '../ai-answer-context';
import { SearchPageSmartAnswerFooter } from '../ai-answer-footer';
import { AIAnswerContentWarningAndBrandSection } from '../ai-answer-footer/ai-answer-footer';
import { AIAnswerLoadingStream } from '../ai-answer-loading/ai-answer-loading-stream';
import GeneratingAnimation from '../ai-answer-loading/generating-animation';
import { aiAnswerCollapseClicked, aiAnswerExpandClicked, aiAnswerExpandShown, getSmartLinksAnalyticsContextData, onAIAnswerLoadingDialogShown, onAIAnswerSourceClick, SmartLinksAnalyticsContextLocation } from '../analytics';
import { NLPSearchResultFormat } from '../types';
import { Collapse } from './collapse';
import { messages } from './messages';
import { AIAnswerSearchBorder, GeneratingContainer, GeneratingText } from './styled';
var styles = {
  spacer: "_4t3idlk8 _ca0qv47k",
  errorContainer: "_ca0qu2gc",
  sourcesContainer: "_ca0qidpf _u5f31ejb _n3tdutpp _19bv1ejb"
};
var MAX_SOURCES = 4;
var SmartAnswerLoadingDialog = function SmartAnswerLoadingDialog() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    partialResponse = _useAIAnswerContext.partialResponse,
    queryReasoning = _useAIAnswerContext.queryReasoning;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  useEffect(function () {
    fireAnalyticsEvent(onAIAnswerLoadingDialogShown(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _getFrontendExperimen = getFrontendExperiment({
      abTestId: 'kd_sain_reasoning_exp'
    }),
    serveSAINReasoningExperiment = _getFrontendExperimen.serveExperiment;

  // no need for the Collapse component when showing the ... generating animation
  if (!partialResponse || (partialResponse === null || partialResponse === void 0 ? void 0 : partialResponse.format) !== NLPSearchResultFormat.MARKDOWN) {
    return /*#__PURE__*/React.createElement(AIAnswerSearchBorder, {
      isLoading: true,
      isStreaming: false
    }, /*#__PURE__*/React.createElement(GeneratingContainer, null, /*#__PURE__*/React.createElement(GeneratingAnimation, null), /*#__PURE__*/React.createElement(GeneratingText, null, serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_generating_rovo))), /*#__PURE__*/React.createElement(AIAnswerContentWarningAndBrandSection, null));
  }
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: getSmartLinksAnalyticsContextData({
      location: SmartLinksAnalyticsContextLocation.SAIN_Q_AND_A_CARD,
      commonAttributes: commonAttributes
    })
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(AIAnswerSearchBorder, {
    isLoading: true,
    isStreaming: true
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(Collapse, {
    collapsed: true,
    isLoading: true,
    isStreaming: true
  }, /*#__PURE__*/React.createElement(AIAnswerLoadingStream, {
    markdown: partialResponse.partialNlpResult
  })), /*#__PURE__*/React.createElement(AIAnswerContentWarningAndBrandSection, null)))));
};
var AnswerCard = function AnswerCard(_ref) {
  var onFMPReached = _ref.onFMPReached,
    onAnswerExpandedChange = _ref.onAnswerExpandedChange;
  var _useAIAnswerContext2 = useAIAnswerContext(),
    hasError = _useAIAnswerContext2.hasError,
    commonAttributes = _useAIAnswerContext2.commonAttributes,
    callbacks = _useAIAnswerContext2.callbacks,
    initiallyExpanded = _useAIAnswerContext2.initiallyExpanded,
    loading = _useAIAnswerContext2.loading;
  var answerFormat = commonAttributes.answerFormat,
    query = commonAttributes.query;
  var _useAnalytics3 = useAnalytics(),
    _useAnalytics4 = _slicedToArray(_useAnalytics3, 1),
    fireAnalyticsEvent = _useAnalytics4[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];

  // reset on each new query
  useEffect(function () {
    setCollapsed(!initiallyExpanded);
    // Notify parent context of initial state
    onAnswerExpandedChange === null || onAnswerExpandedChange === void 0 || onAnswerExpandedChange(!initiallyExpanded);
  }, [query, initiallyExpanded, onAnswerExpandedChange]);

  // Call onFMPReached when answer is loaded
  useEffect(function () {
    if (!loading && !hasError) {
      onFMPReached === null || onFMPReached === void 0 || onFMPReached();
    }
  }, [loading, hasError, onFMPReached]);
  var toggleCollapsedState = function toggleCollapsedState() {
    if (collapsed) {
      fireSAINUsageEvent({
        metCriteria: SainAction.EXPAND_CLICKED,
        commonAttributes: commonAttributes
      });
    }
    setCollapsed(!collapsed);
    // Notify parent context of state change
    onAnswerExpandedChange === null || onAnswerExpandedChange === void 0 || onAnswerExpandedChange(!collapsed);
  };
  var analyticsCallbacks = {
    onExpandedByDefault: function onExpandedByDefault() {
      return fireAnalyticsEvent(aiAnswerExpandShown(commonAttributes));
    },
    onExpandClicked: function onExpandClicked() {
      return fireAnalyticsEvent(aiAnswerExpandClicked(commonAttributes));
    },
    onCollapseClicked: function onCollapseClicked() {
      return fireAnalyticsEvent(aiAnswerCollapseClicked(commonAttributes));
    }
  };
  var sourceClickCallback = useCallback(function (index, source, hostname) {
    var _callbacks$onAIAnswer;
    fireAnalyticsEvent(onAIAnswerSourceClick(_objectSpread({
      sourceIndex: index,
      hostname: hostname,
      sourceProduct: source.product || ''
    }, commonAttributes)));
    fireSAINUsageEvent({
      metCriteria: SainAction.SOURCE_CLICKED,
      sourceProduct: source.product || '',
      commonAttributes: commonAttributes
    });
    callbacks === null || callbacks === void 0 || (_callbacks$onAIAnswer = callbacks.onAIAnswerSourceClick) === null || _callbacks$onAIAnswer === void 0 || _callbacks$onAIAnswer.call(callbacks);
  }, [fireAnalyticsEvent, commonAttributes, fireSAINUsageEvent, callbacks]);
  var answerContent = /*#__PURE__*/React.createElement(Collapse, {
    collapsed: collapsed,
    toggleCollapsedState: toggleCollapsedState,
    expandWhenClickedAnywhere: true,
    isLoading: false,
    callbacks: analyticsCallbacks
  }, /*#__PURE__*/React.createElement(AIAnswerBody, null));
  if (hasError) {
    answerContent = /*#__PURE__*/React.createElement(Box, {
      xcss: styles.errorContainer
    }, /*#__PURE__*/React.createElement(AIAnswerBody, null));
  } else if (answerFormat === NLPSearchResultFormat.JSON) {
    answerContent = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Box, {
      xcss: styles.spacer
    }), /*#__PURE__*/React.createElement(AIAnswerBody, null));
  }
  return /*#__PURE__*/React.createElement(AIAnswerSearchBorder, {
    isLoading: false,
    isStreaming: false
  }, answerContent, !hasError && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.sourcesContainer,
    testId: "ai-answer-sources"
  }, /*#__PURE__*/React.createElement(AISources, {
    sources: commonAttributes.sources,
    searchSessionId: commonAttributes.searchSessionId,
    onClickHandler: sourceClickCallback,
    allowFreeflowLayout: true,
    limit: MAX_SOURCES
  })), /*#__PURE__*/React.createElement(SearchPageSmartAnswerFooter, null));
};

// TODO remove this file when cleaning up `kd_sain_enable_expand_when_streaming`
/**
 * @deprecated This component is the old SmartAnswerCard that didn't support expansion while streaming
 * use SmartAnswerCard instead
 */
export var SmartAnswerCardWithoutStreamingExpand = function SmartAnswerCardWithoutStreamingExpand(_ref2) {
  var onFMPReached = _ref2.onFMPReached,
    onAnswerExpandedChange = _ref2.onAnswerExpandedChange;
  var _useAIAnswerContext3 = useAIAnswerContext(),
    loading = _useAIAnswerContext3.loading;
  return /*#__PURE__*/React.createElement(Fragment, null, loading ? /*#__PURE__*/React.createElement(SmartAnswerLoadingDialog, null) : /*#__PURE__*/React.createElement(AnswerCard, {
    onFMPReached: onFMPReached,
    onAnswerExpandedChange: onAnswerExpandedChange
  }));
};